import {
    FC,
    cloneElement,
    useState,
  } from "react";
  import { useTranslation } from "react-i18next";
  import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    Button,
    DialogContentText,
  } from "@mui/material";
  import { Info } from "@mui/icons-material";
  import { ConfirmationDialogProps } from "../../types/interfaces/CampaingTypes";
  import "../../CampaignManagement.scss";

export const ConfirmationDialogWithTrigger: FC<ConfirmationDialogProps> = ({
    triggerComponent,
    title,
    description,
    onConfirm,
    onCancel,
  }: ConfirmationDialogProps) => {
    
    const { t } = useTranslation();

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: any) => {
      setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const handleConfirm = () => {
      setAnchorEl(null);
      onConfirm();
    };

    const handleCancel = () => {
      setAnchorEl(null);
      if (onCancel != undefined) {
        onCancel();
      }
    };

    return (
      <>
        {cloneElement(triggerComponent, { onClick: handleClick })}
        <Dialog
          open={open}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
          <DialogContent dividers>
            <DialogContentText id="alert-dialog-description" style={{display:"flex"}}>
              <Info style={{ fontSize: 24, color: "#0d6efd", margin: "0px 12px 0 0" }} />
              <Typography gutterBottom>
                {description}
              </Typography>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCancel}>
              {t(
                "campaignManagement.save.step.dialog.action.cancelButton"
              )}
            </Button>
            <Button onClick={handleConfirm} autoFocus>
              {t(
                "campaignManagement.save.step.dialog.action.okButton"
              )}
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  };